import { render, staticRenderFns } from "./CollegeInfoDetail.vue?vue&type=template&id=0c2ce52e&scoped=true&"
import script from "./CollegeInfoDetail.vue?vue&type=script&lang=js&"
export * from "./CollegeInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollegeInfoDetail.vue?vue&type=style&index=0&id=0c2ce52e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ce52e",
  null
  
)

export default component.exports